<div class="ui-g-12">
	<app-dynamic-formly
		[dataSet]="context.data.data"
		[layoutSchema]="context.data.layout"
		[context]="context">
	</app-dynamic-formly>
</div>